'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.device_type_select', {
    url: '/company/:company_id/type_select',
    template: '<device-type-select></device-type-select>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/device_config/type_select/device_type_select.routes.js